import {
  SEND_RESET_PASSWORD_EMAIL_REQUEST,
  SEND_RESET_PASSWORD_EMAIL_SUCCESS,
  SEND_RESET_PASSWORD_EMAIL_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
} from '../constants/actionTypes'

const initialState = {
  isSending: false,
  isResetting: false,
  isFinished: false,
  didReset: false,
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SEND_RESET_PASSWORD_EMAIL_REQUEST:
      return {
        ...state,
        isSending: action.isSending,
        isFinished: action.isFinished,
        errorMessage: '',
      }
    case SEND_RESET_PASSWORD_EMAIL_SUCCESS:
      return {
        ...state,
        isSending: action.isSending,
        isFinished: action.isFinished,
      }
    case SEND_RESET_PASSWORD_EMAIL_FAILURE:
      return {
        ...state,
        isSending: action.isSending,
        isFinished: action.isFinished,
        errorMessage: action.message,
      }
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        isResetting: action.isResetting,
        didReset: action.didReset,
        errorMessage: '',
      }
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isResetting: action.isResetting,
        didReset: action.didReset,
      }
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        isResetting: action.isResetting,
        errorMessage: action.message,
      }
    default:
      return state
  }
}
